import { apiFetch } from "./../../../../../utils/api-fetch";

export interface AiResponseBase {
  confidence: number;
  error: {
    code: string;
    message: string;
  } | null;
}

export interface SliderAiResponse extends AiResponseBase {
  value: number | null;
}

export interface AreaSliderAiResponse extends AiResponseBase {
  importance: number | null;
  implementationQuality: number | null;
}

export interface WordCloudAiResponse extends AiResponseBase {
  terms: string[] | null;
  termsIndexes: number[] | null;
}

export async function transcribeBlob(blob: Blob, language: string) {
  const data = await apiFetch({
    endpoint: `/ai-service/transcribe?language=${language}`,
    method: "POST",
    headers: {
      "Content-Type": blob.type || "audio/webm",
    },
    body: blob,
  });

  return data;
}

export async function getAnswerSuggestion(
  itemId: string,
  userResponse: string
) {
  const data = await apiFetch({
    endpoint: "/ai-service/suggest-item-answer-for-user-reply",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ itemId, userResponse }),
  });

  return data;
}
